interface UpdateExplainerLottieAnimationValues {
  estimatedMiles: number
  perMile: number
  fixedUpfront: number
  monthlyFixedCost: number
  animationData: any
}

export const updateExplainerLottieAnimationValues = ({
  estimatedMiles,
  perMile,
  fixedUpfront,
  monthlyFixedCost,
  animationData,
}: UpdateExplainerLottieAnimationValues) => {
  const animationDataCopy = JSON.parse(JSON.stringify(animationData))

  const avgMonthlyMileageCost = (estimatedMiles / 12) * (perMile / 100)
  animationDataCopy.assets[0].layers[1].t.d.k[0].s.t = `£${fixedUpfront}`
  animationDataCopy.assets[4].layers[0].ef[0].ef[0].v.x = `var $bm_rt;\n$bm_rt = $bm_sum(${monthlyFixedCost}, effect('Monthly Addition')('Slider').value);`
  animationDataCopy.assets[4].layers[8].t.d.k[0].s.t = `£${monthlyFixedCost}`
  animationDataCopy.assets[4].layers[4].t.d.k[0].s.t = `${perMile.toFixed(1)}p`

  // Ranges - Monthly fixed added to these. Layers [0] [X] [X] [0] [0] [X]
  // Average won't exactly match sticky banner due to how we calc - no fixed cost for 12th month
  animationDataCopy.assets[4].layers[0].ef[1].ef[0].v.k[2].s = [avgMonthlyMileageCost]
  animationDataCopy.assets[4].layers[0].ef[1].ef[0].v.k[3].s = [avgMonthlyMileageCost]
  animationDataCopy.assets[4].layers[0].ef[1].ef[0].v.k[6].s = [((estimatedMiles * 1.05) / 12) * (perMile / 100)]

  return animationDataCopy
}
